import { type UseNectarAnalyticsProps, useNectarAnalytics } from '~/hooks/useNectarAnalytics';

import { NectarAnalyticsContext } from './NectarAnalyticsContext';

interface NectarAnalyticsProviderProps {
  children: React.ReactNode;
  analyticsProps: UseNectarAnalyticsProps;
}

export const NectarAnalyticsProvider: React.FC<NectarAnalyticsProviderProps> = ({ children, analyticsProps }) => {
  const analytics = useNectarAnalytics(analyticsProps);

  return <NectarAnalyticsContext.Provider value={analytics}>{children}</NectarAnalyticsContext.Provider>;
};
